// extracted by mini-css-extract-plugin
export var formContainer = "_ev-0";
export var message = "_ev-1";